import { productReviewForm } from './productReviewForm.js'
import { productOverviewNav } from './productOverviewNav.js'
import { productOverviewResetStyles } from './productOverviewResetStyles.js'
import { productOverviewFormatStyles } from './productOverviewFormatStyles.js'
import { getSkinUrl } from '../../utils/utils'

document.addEventListener('DOMContentLoaded', function () {
    ;(function () {
        const origAddEventListener = EventTarget.prototype.addEventListener
        EventTarget.prototype.addEventListener = function (
            type,
            listener,
            options
        ) {
            if (
                type === 'touchstart' ||
                type === 'touchmove' ||
                type === 'mousedown'
            ) {
                if (typeof options === 'object' && options !== null) {
                    options = Object.assign({}, options, { passive: false })
                } else if (typeof options === 'boolean') {
                    options = { capture: options, passive: false }
                } else {
                    options = { passive: false }
                }
            }
            return origAddEventListener.call(this, type, listener, options)
        }
    })()

    productReviewForm()
    productOverviewNav()
    productOverviewResetStyles()
    productOverviewFormatStyles()

    /*
     * Responsive tables in product page content
     * Wraps tables with a div to make them responsive
     */
    const tableSelector = Array.from(
        document.querySelectorAll('.product-content__details table')
    )
    tableSelector.forEach(function (el) {
        el.outerHTML =
            '<div class="table-responsive">' + el.outerHTML + '</div>'
    })

    /**
     * SimpleLightbox
     */
    const lightboxEl = Array.from(
        document.querySelectorAll('.product-gallery-link')
    )
    const productGalleryTriggers = Array.from(
        document.querySelectorAll('.open-product-gallery-js')
    )

    if (lightboxEl.length) {
        function handleTranslateYChange(mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'data-translate-y'
                ) {
                    const newValue = mutation.target.getAttribute(
                        'data-translate-y'
                    )

                    const nav = document.querySelector('.sl-navigation')
                    const closeBtn = document.querySelector('.sl-close')
                    const cartWidget = document.querySelector('.cart-widget')
                    if (!mutation.target.classList.contains('add-zoom')) {
                        if (newValue != 0) {
                            cartWidget.style.display = 'none'
                            nav.style.display = 'none'
                            closeBtn.style.display = 'none'
                        } else {
                            cartWidget.style.display = 'flex'
                            nav.style.display = 'block'
                            closeBtn.style.display = 'block'
                        }
                    }
                }
            }
        }

        const observer = new MutationObserver(handleTranslateYChange)
        const config = { attributes: true }

        import('simplelightbox').then((module) => {
            const { default: SimpleLightbox } = module
            const productGallery = new SimpleLightbox(lightboxEl, {
                showCounter: false,
                history: false,
                doubleTapZoom: 1,
                nav: false,
                closeText:
                    '<span data-icon="close">\n' +
                    '            <img src="' +
                    getSkinUrl(`icons/close.svg`) +
                    '" class="sl-close-icon icon--invert">\n' +
                    '        </span>',
                navText: ['<p>&lsaquo;</p>', '<p>&rsaquo;</p>']
            })

            const cartWidget = document.getElementById('cart-widget')
            productGallery.on('shown.simplelightbox', function () {
                if (cartWidget) {
                    productGallery.domNodes.image.appendChild(cartWidget)
                    productGallery.domNodes.image.appendChild(
                      productGallery.domNodes.navigation
                    )

                    const parent = productGallery.domNodes.image
                    const firstChild = parent.firstChild
                    parent.insertBefore(productGallery.domNodes.closeButton, firstChild)

                    productGallery.domNodes.closeButton.querySelector(
                      '.sl-close-icon'
                    ).style.display = 'block'
                }
            })

            productGalleryTriggers.forEach((el) => {
                el.addEventListener('click', function (e) {
                    e.preventDefault()
                    const slideId = this.dataset.slideId
                    productGallery.open(productGallery.elements[slideId || 0])
                    const image = document.querySelector('.sl-image img')
                    image.addEventListener('dblclick', (e) => {
                        const nav = document.querySelector('.sl-navigation')
                        const closeBtn = document.querySelector('.sl-close')
                        const cartWidget = document.querySelector(
                            '.cart-widget'
                        )
                        image.classList.toggle('add-zoom')
                        if (image.classList.contains('add-zoom')) {
                            cartWidget.style.display = 'none'
                            nav.style.display = 'none'
                            closeBtn.style.display = 'none'
                        } else {
                            cartWidget.style.display = 'flex'
                            nav.style.display = 'block'
                            closeBtn.style.display = 'block'
                        }
                    })
                    observer.observe(image, config)
                })
            })

            const widgetBtn = document.querySelector('.cart-widget__btn')
            if (widgetBtn) {
                widgetBtn.addEventListener('click', () => {
                    setTimeout(() => {
                        productGallery.close()
                    })
                })
            }

            productGallery.on('close.simplelightbox', function () {
                const cartWidget = document.getElementById('cart-widget')
                const container = document.querySelector('.js-widget-container')
                if (cartWidget) {
                    container.append(cartWidget)
                }
                setTimeout(() => {
                    if (productGalleryTriggers.length > 0) {
                        productGalleryTriggers[0].focus()
                    }
                }, 500)
            })
        })
        import('simplelightbox/src/simple-lightbox.scss')
        import('@scss/shop/plugins/simple-lightbox.scss')
    } else {
        lightboxEl.forEach((el) => {
            el.addEventListener('click', function (e) {
                e.preventDefault()
            })
        })
    }
})
